import styles from "./BallroomOverview.module.css";

export default function BallroomOverview({ hotel, ballroom })
{  

  return (
    <section className={styles.section}>
      <div className={styles.container}>

        <span className={styles.heading}>
          ABOUT THE VENUE
        </span>

        <h2 className={styles.title}>
          {ballroom?.name}
        </h2>

        <p className={styles.description}>
          {ballroom?.description}
        </p>

        {/* {hotel.description && (
          <p className={styles.hotelDescription}>
            {hotel.description}
          </p>
        )} */}

      </div>
    </section>
  );
}